// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"126":"6007149d","503":"dec8898e","603":"511ef12a"}[chunkId] + ".css";
};